import { EmailStatus, SelfRegisterType } from '~/api/auth';
import { SHARED_SEARCH_PATH } from '~/pages/search/search.constants';

export const GET_ACCESS_STEP = 'get-access';

export type LoginStep = SelfRegisterType | typeof GET_ACCESS_STEP;

export const emailStatusLoginStepMap: Record<EmailStatus, SelfRegisterType> = {
  [EmailStatus.UNKNOWN]: SelfRegisterType.REQUEST_INVITE,
  [EmailStatus.NEW]: SelfRegisterType.REGISTER_YOURSELF,
  [EmailStatus.PENDING]: SelfRegisterType.RESEND_WELCOME_INVITE,
  [EmailStatus.REGISTERED]: SelfRegisterType.ENTER_PASSWORD,
};

export const isSharedLinkRedirect = (
  redirect: string | null | undefined,
): boolean => redirect?.startsWith(SHARED_SEARCH_PATH) ?? false;
